import OriginTracer from '@atlassiansox/origin-tracing/origin-tracer';
import { useFirePostOfficeAnalyticsEvents } from '@post-office/analytics';
import { useMemo } from 'react';

export const useOriginTracing = (product?: string, url?: string): string | undefined => {
	const { fireAnalyticsEvent } = useFirePostOfficeAnalyticsEvents();

	return useMemo<string | undefined>(() => {
		if (!product || !url) {
			return url;
		}
		const originTracer = new OriginTracer({ product });
		const urlWithOriginTracing = originTracer.addToUrl(url);

		fireAnalyticsEvent({
			eventType: 'operational',
			action: 'generated',
			actionSubject: 'origin',
			attributes: {
				...originTracer.toAnalyticsAttributes({ hasGeneratedId: true }),
			},
		});

		return urlWithOriginTracing;
	}, [fireAnalyticsEvent, product, url]);
};
